import { CRMTypes } from '@labrav/common'
import {
  deleteSingleReferralTemplate,
  deleteTemplateSalesforce,
} from '../../../api/mappingManager'

export const deleteMarketplaceTemplateAPI = async ({
  crmId,
  templateId,
  crmType,
  accountId,
}: {
  crmId: string
  templateId: string
  crmType?: CRMTypes
  accountId?: string
}) => {
  if (crmType === CRMTypes.salesforce) {
    return await deleteTemplateSalesforce(crmId, accountId ?? '', templateId)
  }

  return await deleteSingleReferralTemplate(crmId, templateId)
}
